module.exports = __webpack_public_path__ + "img/guohuali.5bb494c2.jpg";